import { isNotDefined } from '@sgme/fp';

import { isAlgoOrderType } from '@/store/blotter/api/types/BlotterOrderEntryFromBackend.ts';
import { summonOrder } from '@/store/blotter/workflows/summonOrder/action.ts';
import type { StartAppListening } from '@/store/listenerMiddleware.ts';
import { registerOrder } from '@/store/orders/listeners/registerEspOrderListeners.ts';

// ██╗     ██╗███████╗████████╗███████╗███╗   ██╗███████╗██████╗ ███████╗
// ██║     ██║██╔════╝╚══██╔══╝██╔════╝████╗  ██║██╔════╝██╔══██╗██╔════╝
// ██║     ██║███████╗   ██║   █████╗  ██╔██╗ ██║█████╗  ██████╔╝███████╗
// ██║     ██║╚════██║   ██║   ██╔══╝  ██║╚██╗██║██╔══╝  ██╔══██╗╚════██║
// ███████╗██║███████║   ██║   ███████╗██║ ╚████║███████╗██║  ██║███████║
// ╚══════╝╚═╝╚══════╝   ╚═╝   ╚══════╝╚═╝  ╚═══╝╚══════╝╚═╝  ╚═╝╚══════╝

export const registerSummonOrderListener = (startAppListening: StartAppListening) => {
  startAppListening({
    actionCreator: summonOrder,
    // engage ESP stream for the newly created order tile
    effect: async (action, api) => {
      const {
        payload: { tileId, entry },
      } = action;

      if (isNotDefined(entry.clientId)) {
        return;
      }

      const previousState = api.getOriginalState();
      const currentState = api.getState();

      const previousTile = previousState.orders[tileId];
      const currentTile = currentState.orders[tileId];

      // nothing to do
      // if the currency pair hasn't changed
      if (
        previousTile?.properties.currencyPair?.currency1 === currentTile?.properties.currencyPair?.currency1 &&
        previousTile?.properties.currencyPair?.currency2 === currentTile?.properties.currencyPair?.currency2
      ) {
        return undefined;
      }

      if (isAlgoOrderType(entry.orderType)) {
        return registerOrder(tileId, api);
      }
    },
  });
};
